import { Loader } from '@googlemaps/js-api-loader'
import { PdGoogleMap } from '@/js/App/PdGoogleMap'

declare global {
	interface Window {
		pdGoogleMap: PdGoogleMap
	}
}

class PdMapLoader {
	private loaded: boolean = false
	private mapElement: HTMLElement

	public constructor() {
		this.mapElement = document.getElementById('map') as HTMLElement

		const mediaQueryString = this.mapElement.dataset.mediaQuery

		if (!mediaQueryString) {
			this.loadMap()
		} else {
			this.loadMapOnMedia(window.matchMedia(mediaQueryString))
		}
	}

	private loader: Loader = new Loader({
		apiKey: 'AIzaSyB_KDajyt-sWpZH79CCFJuwB-oAXUrWAjI', // todo
		version: 'weekly'
	})

	private loadMapOnMedia(mediaQuery: MediaQueryList): void {
		if (mediaQuery.matches) {
			this.loadMap()
			return
		}

		mediaQuery.addEventListener('change', (event) => {
			if (!event.matches) {
				return
			}

			this.loadMap()
		})
	}

	private loadMap(): void {
		if (this.loaded) {
			return
		}

		this.loaded = true

		this.loader.importLibrary('maps').then(({ Map }) => {
			window.pdGoogleMap = new PdGoogleMap(
				new Map(this.mapElement, {
					center: { lat: -34.397, lng: 150.644 },
					zoom: 8,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				})
			)
		})
	}
}

new PdMapLoader()
